import * as localForage from 'localforage';
import immutablePersistenceTransform from '../helpers/ImmutablePersistenceTransform';

const REDUX_PERSIST = {
    active: true,
    reducerVersion: '3.0.8',// bump me in order to clean the stored data
    storeConfig: {
        storage: localForage,
        whitelist: ['SagaAuth', 'App', 'Language', 'SagaProject'], // store only necessary keys.
        transforms: [immutablePersistenceTransform]
    }
};

export default REDUX_PERSIST;



// WEBPACK FOOTER //
// ./src/config/ReduxPersist.ts